<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in SHOP_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <CategoryOne
        :value="listQuery.categoryId"
        @valueFunc="getCategoryValueFunc"
        type="queryCategory"
        :styleRef="{ width: '200px', marginRight: '10px' }"
        class="filter-item"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">店铺数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="商户名称"
        align="center"
        prop="mchName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="品牌名称"
        align="center"
        prop="brandName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="名称"
        align="center"
        prop="name"
        width="100"
      ></el-table-column>
      <el-table-column
        label="地址"
        align="center"
        prop="provinceName"
        width="300px"
      >
        <template slot-scope="scope">
          {{
            getAddress(
              scope.row.countryName,
              scope.row.provinceName,
              scope.row.cityName,
              scope.row.areaName
            )
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="主营类目"
        align="center"
        prop="caterotyName"
        width="200px"
      ></el-table-column>
      <el-table-column label="logo" align="center" prop="logo" width="140px">
        <template slot-scope="scope">
          <el-image
            :src="getTableThumbnailImg(scope.row.logo)"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        label="商品描述评分"
        align="center"
        prop="goodsScore"
      ></el-table-column>
      <el-table-column
        label="卖家服务评分"
        align="center"
        prop="sellerScore"
      ></el-table-column>
      <el-table-column
        label="物流服务评分"
        align="center"
        prop="logisticsScore"
      ></el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ getValue(SHOP_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="审核通过时间"
        align="center"
        width="160px"
      >
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.checkedTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="160px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="160px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="checkExamineVisible(true, scope.row)"
            :disabled="SHOP_STATUS_VAL.TO_BE_REVIEWED !== scope.row.status"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="50%"
      top="60px"
      @close="checkDialogFormVisible(false, {}, '')"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="地址" prop="cascadeRegion">
          <CascadeRegion
            :value="form.cascadeRegion"
            @valueFunc="getQueryValueFunc"
            type="formCascadeRegion"
            :styleRef="{ width: '100%' }"
          />
        </el-form-item>
        <el-form-item label="店铺名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="店铺LOGO" prop="logo">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.SHOP"
            @valueFunc="getImgsValueFunc"
            paramsType="shopLogo"
            :model="form.logo"
            :maxCount="1"
          />
        </el-form-item>
        <el-form-item label="主营类目" prop="busCategory">
          <CategoryOne
            :value="form.busCategory"
            @valueFunc="getCategoryValueFunc"
            type="formCategory"
            :styleRef="{ width: '100%' }"
            :isMultiple="true"
          />
        </el-form-item>
        <el-form-item label="品牌" prop="brandId">
          <Brand
            v-model="form.brandId"
            type="formBrand"
            :styleRef="{ width: '100%' }"
            @valueFunc="getBrandValueFunc"
          />
        </el-form-item>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>发货地址</span>
          </div>
          <div class="text item">
            <el-form-item label="地区" prop="shippAddr.shippAddrRegion">
              <CascadeRegion
                :value="form.shippAddr.shippAddrRegion"
                @valueFunc="getQueryValueFunc"
                type="formShippAddrRegion"
                :styleRef="{ width: '100%' }"
              />
            </el-form-item>
            <el-form-item label="详细地址" prop="shippAddr.a">
              <el-input v-model="form.shippAddr.a" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="联系姓名" prop="shippAddr.n">
              <el-input v-model="form.shippAddr.n" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="联系电话" prop="shippAddr.t">
              <el-input v-model="form.shippAddr.t" placeholder="请输入" />
            </el-form-item>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>收货地址</span>
          </div>
          <div class="text item">
            <el-form-item label="地区" prop="receAddr.receAddrRegion">
              <CascadeRegion
                :value="form.receAddr.receAddrRegion"
                @valueFunc="getQueryValueFunc"
                type="formDeliveryRegion"
                :styleRef="{ width: '100%' }"
              />
            </el-form-item>
            <el-form-item label="详细地址" prop="receAddr.a">
              <el-input v-model="form.receAddr.a" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="联系姓名" prop="receAddr.n">
              <el-input v-model="form.receAddr.n" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="联系电话" prop="receAddr.t">
              <el-input v-model="form.receAddr.t" placeholder="请输入" />
            </el-form-item>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!--    审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="examineForm"
        :rules="examineRules"
        :model="examineForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="商户ID">
          <span>{{ examineObj.mchId }}</span>
        </el-form-item>
        <el-form-item label="商户名称">
          <span>{{ examineObj.mchName }}</span>
        </el-form-item>
        <el-form-item label="品牌名称">
          <span>{{ examineObj.brandName }}</span>
        </el-form-item>
        <el-form-item label="店铺名称">
          <span>{{ examineObj.name }}</span>
        </el-form-item>
        <el-form-item label="地址">
          <span>{{ examineObj.provinceName }} | {{ examineObj.cityName }}</span>
        </el-form-item>
        <el-form-item label="类目">
          <span>{{ examineObj.caterotyName }}</span>
        </el-form-item>
        <el-form-item label="品牌logo ">
          <el-image
            style="width: 100px; height: 100px"
            :src="examineObj.logo"
            fit="cover"
          ></el-image>
        </el-form-item>
        <el-form-item label="商品描述评分">
          <span>{{ examineObj.goodsScore }}</span>
        </el-form-item>
        <el-form-item label="卖家服务评分">
          <span>{{ examineObj.sellerScore }}</span>
        </el-form-item>
        <el-form-item label="物流服务评分">
          <span>{{ examineObj.logisticsScore }}</span>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="审核结果" prop="status">
          <el-select
            v-model="examineForm.status"
            placeholder="状态"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in SHOP_EXAMINE_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkExamineVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="examineOk" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStoreList, editShop, checkShop } from "@/api/store";
import {
  getFileName,
  formatApiDate,
  splitMenus,
  getTableThumbnailImg
} from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  SHOP_STATUS,
  UPLOAD_IMG_TYPE,
  SHOP_EXAMINE_STATUS,
  SHOP_STATUS_VAL
} from "@/utils/enumUtile";
import CascadeRegion from "@/views/components/cascadeRegion.vue";
import CategoryOne from "@/views/components/categoryOne.vue";
import Brand from "@/views/components/brand.vue";
import UploadList from "@/views/components/uploadList.vue";
import { getAddress } from "@/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    SHOP_STATUS() {
      return SHOP_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    SHOP_EXAMINE_STATUS() {
      return SHOP_EXAMINE_STATUS;
    },
    SHOP_STATUS_VAL() {
      return SHOP_STATUS_VAL;
    }
  },
  components: { CascadeRegion, CategoryOne, Brand, UploadList },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        status: null,
        provinceId: null,
        cityId: null,
        categoryId: null
      },
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        busCategory: [
          { required: true, message: "主营类目不能为空", trigger: "change" }
        ],
        logo: [
          { required: true, message: "店铺LOGO不能为空", trigger: "change" }
        ],
        name: [
          { required: true, message: "店铺名称不能为空", trigger: "change" }
        ],
        cascadeRegion: [
          { required: true, message: "地址不能为空", trigger: "change" }
        ],
        "shippAddr.shippAddrRegion": [
          { required: true, message: "发货地址不能为空", trigger: "change" }
        ],
        "shippAddr.a": [
          { required: true, message: "详细地址不能为空", trigger: "change" }
        ],
        "shippAddr.n": [
          { required: true, message: "联系姓名不能为空", trigger: "change" }
        ],
        "shippAddr.t": [
          { required: true, message: "联系电话不能为空", trigger: "change" }
        ],
        "receAddr.receAddrRegion": [
          { required: true, message: "收货地址不能为空", trigger: "change" }
        ],
        "receAddr.a": [
          { required: true, message: "详细地址不能为空", trigger: "change" }
        ],
        "receAddr.n": [
          { required: true, message: "联系姓名不能为空", trigger: "change" }
        ],
        "receAddr.t": [
          { required: true, message: "联系电话不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        cascadeRegion: [],
        countryId: null, //国家ID
        provinceId: null, //省份ID
        cityId: null, // 城市ID
        areaId: null, // 区域ID
        name: null,
        logo: [],
        categoryArr: [],
        busCategory: null,
        brandId: null,
        shippAddr: {
          shippAddrRegion: [], // 记得删掉
          g: null, // 国家
          p: null, // 省份
          c: null, // 城市
          d: null, // 地区
          a: null, // 详细地址
          t: null, // 电话
          n: null // 联系人
        }, // 发货地址信息
        receAddr: {
          receAddrRegion: [], // 记得删掉
          g: null, // 国家
          p: null, // 省份
          c: null, // 城市
          d: null, // 地区
          a: null, // 详细地址
          t: null, // 电话
          n: null // 联系人
        } // 收货地址信息
      },
      btnLoading: false,
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [
          { required: true, message: "审核结果不能为空", trigger: "change" }
        ]
      },
      examineForm: {
        id: 0, //
        status: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getAddress,
    getValue,
    getTableThumbnailImg,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      if (form.categoryId && form.categoryId.length !== 0) {
        // const categoryArr = [];
        // encapsulationMenus(form.category, categoryArr);
        params.categoryId =
          form.categoryId.length !== 0 ? form.categoryId.join(",") : "";
      }
      getStoreList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.cascadeRegion = [
          editObj.countryId,
          editObj.provinceId,
          editObj.cityId,
          editObj.areaId
        ];
        this.form.countryId = editObj.countryId;
        this.form.provinceId = editObj.provinceId;
        this.form.cityId = editObj.cityId;
        this.form.areaId = editObj.areaId;
        this.form.name = editObj.name;
        this.form.brandId = editObj.brandId;
        this.form.busCategory = splitMenus(editObj.busCategory);
        if (editObj.logo) {
          const attDataArr = [];
          attDataArr.push({
            url: editObj.logo,
            dbUrl: editObj.logo,
            name: getFileName(editObj.logo)
          });
          this.form.logo = attDataArr;
        }
        if (editObj.shippingAddress) {
          const data = JSON.parse(editObj.shippingAddress);
          this.form.shippAddr = {
            shippAddrRegion: [data.g, data.p, data.c, data.d],
            g: data.g,
            p: data.p,
            c: data.c,
            d: data.d,
            a: data.a,
            t: data.t,
            n: data.n
          };
          console.log("this.form.shippAddr", this.form.shippAddr);
        }
        if (editObj.receivingAddress) {
          const data = JSON.parse(editObj.receivingAddress);
          this.form.receAddr = {
            receAddrRegion: [data.g, data.p, data.c, data.d],
            g: data.g,
            p: data.p,
            c: data.c,
            d: data.d,
            a: data.a,
            t: data.t,
            n: data.n
          };
        }
      }
      if (!status) {
        this.form.id = 0;
        this.form.countryId = null;
        this.form.provinceId = null;
        this.form.cityId = null;
        this.form.areaId = null;
        this.form.cascadeRegion = [];
        this.form.name = null;
        this.form.logo = [];
        this.form.busCategory = null;
        this.form.brandId = null;
        this.form.categoryArr = [];
        this.form.busCategory = null;
        this.form.shippAddr = {
          shippAddrRegion: [],
          g: null,
          p: null,
          c: null,
          d: null,
          a: null,
          t: null,
          n: null
        };
        this.form.receAddr = {
          receAddrRegion: [],
          g: null,
          p: null,
          c: null,
          d: null,
          a: null,
          t: null,
          n: null
        };
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 获取省市区街道
     * @param type
     * @param resultArr
     */
    getQueryValueFunc(type, resultArr) {
      if (type === "formCascadeRegion") {
        this.form.cascadeRegion = resultArr;
        this.form.countryId = resultArr[0] || "";
        this.form.provinceId = resultArr[1] || "";
        this.form.cityId = resultArr[2] || "";
      } else if (type === "formShippAddrRegion") {
        this.form.shippAddr.shippAddrRegion = resultArr;
        this.form.shippAddr.g = resultArr[0] || "";
        this.form.shippAddr.p = resultArr[1] || "";
        this.form.shippAddr.c = resultArr[2] || "";
        this.form.shippAddr.d = resultArr[3] || "";
      } else if (type === "formDeliveryRegion") {
        this.form.receAddr.receAddrRegion = resultArr;
        this.form.receAddr.g = resultArr[0] || "";
        this.form.receAddr.p = resultArr[1] || "";
        this.form.receAddr.c = resultArr[2] || "";
        this.form.receAddr.d = resultArr[3] || "";
      }
    },
    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "formCategory") {
        this.form.busCategory = resultArr;
      } else if (type === "queryCategory") {
        this.listQuery.categoryId = resultArr;
      }
    },
    /**
     * 获取品牌
     * @param type
     * @param resultArr
     */
    getBrandValueFunc(type, resultArr) {
      if (type === "formBrand") {
        this.form.brandId = resultArr;
      }
    },

    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          // const busCategoryArr = [];
          // encapsulationMenus(form.busCategory, busCategoryArr);
          delete form.shippAddr.shippAddrRegion;
          delete form.receAddr.receAddrRegion;
          const params = {
            countryId: form.countryId,
            provinceId: form.provinceId,
            cityId: form.cityId,
            name: form.name,
            brandId: form.brandId,
            shippAddr: JSON.stringify(form.shippAddr),
            receAddr: JSON.stringify(form.receAddr),
            busCategory:
              form.busCategory.length !== 0 ? form.busCategory.join(",") : ""
          };
          if (form.logo && form.logo.length !== 0) {
            const urlArr = form.logo.map(obj => obj["dbUrl"]);
            params.logo = urlArr.join(",");
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editShop(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "shopLogo") {
        this.form.logo = value;
      }
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          this.btnLoading = true;
          checkShop(params)
            .then(() => {
              this.getList();
              this.checkExamineVisible(false);
              this.$notify({
                title: "成功",
                message: "审核成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
    // 审核 end
  }
};
</script>
<style scoped lang="scss">
.box-card {
  margin-bottom: 10px;
}
</style>
